module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" " + _vm._s(_vm.date) + " " + _vm._s(_vm.$trad.common.by) + " "), _c('strong', [_vm._v(_vm._s(_vm.author))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-368a2a95","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planoList/components/author-badge.vue
// module id = 3119
// module chunks = 0